import axiosInstance from '../utils/api';

const commonService = {
  getOTPForRegistration(data) {
    return axiosInstance.post('/otp', data);
  },

  register(data) {
    return axiosInstance.post('/users/register', data);
  },
  login(data) {
    return axiosInstance.post('/users/login', data);
  },
  forgotPassword(data) {
    return axiosInstance.post('users/forgot-password', data);
  },
  changePassword(userId, data) {
    return axiosInstance.patch(`users/${userId}/change-password`, data);
  },
  getUserLogs() {
    return axiosInstance.get('/users/log/');
  },
  getUsers() {
    return axiosInstance.get('/users/');
  },
  approveIPAddress(user, id) {
    return axiosInstance.patch(
      `/users/${user}/ip-requests/${id}/approve`,
      null
    );
  },
  disapproveIPAddress(user, id) {
    return axiosInstance.patch(
      `/users/${user}/ip-requests/${id}/disapprove`,
      null
    );
  },
  updateUserStatus(id) {
    return axiosInstance.patch(`/users/${id}/approve`, null);
  },
  updateUser(id, data) {
    return axiosInstance.patch(`/users/${id}/`, data);
  },
  getFormFields(type, role = 'i') {
    return axiosInstance.get(`/forms/get-data/${type}/${role}`);
  },
  getZipCodes(searchTerm) {
    return axiosInstance.get(`/forms/zip-codes/?zipCode=${searchTerm}`);
  },
  getAllStates() {
    return axiosInstance.get(`/forms/states`);
  },
  getStateByZip(zip) {
    return axiosInstance.get(`/forms/state/${zip}`);
  },
  submitPriceLoanForm(data) {
    return axiosInstance.post(`/forms/loan/price`, data);
  },
  submitInterestLoanForm(data) {
    return axiosInstance.post(`/forms/loan/interest`, data);
  },
  generateReport(data) {
    return axiosInstance.post(`/output/generate-report`, data);
  },
  uploadCSV(data) {
    return axiosInstance.post(`/forms/loan/upload`, data);
  },
  getLookupRuns(page, pagesize, query = '') {
    return axiosInstance.get(
      `/output/lookup-run?page=${page}&pagesize=${pagesize}&query=${query}`
    );
  },
  getMyRuns() {
    return axiosInstance.get(`/output/my-runs`);
  },
  encompassPrefill(loanNumber) {
    return axiosInstance.post(`/encompass/prefill`, { loanNumber });
  },
  loadMyRun(id) {
    return axiosInstance.post(`/output/my-runs/load`, { id });
  },
  ratesStatus() {
    return axiosInstance.get(`/rates/status`);
  },
  ratesPreview(formData) {
    return axiosInstance.post(`/rates/preview`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  ratesPublish(token) {
    return axiosInstance.post(`/rates/publish`, { token });
  },
  ratesRollback(date) {
    return axiosInstance.post(`/rates/rollback`, { date });
  },
  engineStatus() {
    return axiosInstance.get(`/rates/engine/status`);
  },
  engineQuick() {
    return axiosInstance.post(`/rates/engine/quick`, {}, { timeout: 300000 });
  },
  engineSnapshot() {
    return axiosInstance.post(`/rates/engine/snapshot`, {});
  },
  engineAb() {
    return axiosInstance.post(`/rates/engine/ab`, {});
  },
  engineAbStatus() {
    return axiosInstance.get(`/rates/engine/ab-status`);
  },
  engineReleaseEmail(version, prevVersion, notes) {
    return axiosInstance.post(`/rates/engine/release-email`, { version, prevVersion, notes }, { timeout: 300000 });
  },
  ratesKnobs() {
    return axiosInstance.get(`/rates/knobs`);
  },
  ratesSaveKnobs(knobs, rev) {
    return axiosInstance.put(`/rates/knobs`, { knobs, rev });
  },
  ratesDerivePreview(payload) {
    return axiosInstance.post(`/rates/derive-preview`, payload, { timeout: 180000 });
  },
  ratesPartners() {
    return axiosInstance.get(`/rates/partners`);
  },
  ratesPublish620(entries, effectiveDate, force) {
    return axiosInstance.post(`/rates/partners/620`, { entries, effectiveDate, force });
  },
  ratesPublishCorrespondents(rows, effectiveDate, force) {
    return axiosInstance.post(`/rates/partners/correspondents`, { rows, effectiveDate, force });
  },
  ratesPublishTags(rows, effectiveDate, force) {
    return axiosInstance.post(`/rates/partners/tags`, { rows, effectiveDate, force });
  },
  ratesPublishBumps(rows, effectiveDate, force) {
    return axiosInstance.post(`/rates/partners/bumps`, { rows, effectiveDate, force });
  },
  ratesPartnerRollback(family, date) {
    return axiosInstance.post(`/rates/partners/rollback`, { family, date });
  }
};

const authService = {
  getToken() {
    const tokenString = sessionStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    return userToken;
  },

  saveToken(userToken) {
    sessionStorage.setItem('token', JSON.stringify(userToken));
    // setToken(userToken.token);
  }
};

export { commonService, authService };
